<template>
    <div>
        <v-container style="max-width:1000px">
            <h1 style="text-align:center">Välj datum</h1>
            <v-container>
                <v-row>
                    <v-col>
                        <v-date-picker
                            v-model="date"
                            locale="sv"
                            :show-current="true"
                            :min="
                                nowDate
                            "
                        >
                        </v-date-picker
                        ><br />
                    </v-col>
                    <v-col>
                        <v-container v-for="(date, i) in dates" :key="i">
                            <v-row>
                                <v-label>{{ toDDMMYY(date) }}</v-label>
                                <v-menu
                                    ref="menu"
                                    v-model="menu2[i]"
                                    :close-on-content-click="false"
                                    :return-value.sync="time"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="1000px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="time"
                                            :label="
                                                ftime[i]
                                                    ? `${stime[i]}-${ftime[i]}`
                                                    : 'Välj tid'
                                            "
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <div style="display:flex;">
                                        <v-time-picker
                                            v-if="menu2[i]"
                                            v-model="stime[i]"
                                            format="24hr"
                                            :allowed-minutes="allowedMinutes"
                                        ></v-time-picker>
                                        <v-time-picker
                                            v-if="menu2[i]"
                                            v-model="ftime[i]"
                                            format="24hr"
                                            :allowed-minutes="allowedMinutes"
                                            :min="stime[i]"
                                        ></v-time-picker>
                                        <v-btn @click="setTime(date, i)" text
                                            ><v-icon>fas fa-plus</v-icon></v-btn
                                        >
                                    </div>
                                </v-menu>

                                <!--                                <input
                                    v-model="stime[i]"
                                    type="time"
                                    class="inputtime"
                                />
                                <input
                                    v-model="ftime[i]"
                                    type="time"
                                    class="inputtime"
                                />-->

                                <v-btn @click="removeDate(i)" text
                                    ><v-icon>fas fa-minus</v-icon></v-btn
                                >
                                <v-btn
                                    v-show="dates.indexOf(dates[i]) == i"
                                    @click="add(date)"
                                    text
                                    >Alternativ tid</v-btn
                                >
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
                <div>
                    <v-row
                        ><v-switch
                            v-model="replyDeadline"
                            label="Sätt en deadline för svar"/>
                            <!-- <input
                            class="input"
                            v-model="replyDate"
                            v-show="replyDeadline"
                            type="date"
                    /> -->
                    <v-date-picker
                            v-model="replyDate"
                            locale="sv"
                            v-show="replyDeadline"
                            :min="nowDate"
                        >
                        </v-date-picker
                        >
                    </v-row>
                    <v-row>
                        <v-switch
                            v-model="ifNeeded"
                            label="Lägg till
                        alternativet 'Om det behövs' för att fånga upp även
                        halvbra tidsförslag."
                        />
                    </v-row>
                    <v-row>
                        <v-checkbox
                            v-model="oneAns"
                            label="Begränsa till ett svar"
                        />
                        <v-checkbox v-model="hidSchedule" label="Dold schema" />
                    </v-row>
                    <v-row>
                        <v-checkbox
                            v-model="contactInfo"
                            label="Be om kontaktinformation"
                        />
                    </v-row>
                    <v-row v-if="contactInfo" style="display:flex">
                        <v-text-field label="Contact Info 1" v-model="ci0" />
                        <v-text-field label="Contact Info 2" v-model="ci1" />
                        <v-text-field label="Contact Info 3" v-model="ci2" />
                        <v-text-field label="Contact Info 4" v-model="ci3" />
                        <v-text-field label="Contact Info 5" v-model="ci4" />
                    </v-row>
                    <v-row>
                        <v-switch
                            v-model="adminOnly"
                            label="Endast åtkomst för Admin"
                        />
                    </v-row>
                </div>
                <v-btn
                    @click="back"
                    style="background-color:#ffa500;margin-right:3px"
                    ><v-icon style="font-size:15px;margin-left:3px"
                        >fas fa-arrow-left</v-icon
                    >Tillbaka
                </v-btn>
                <v-btn @click="next" style="background-color:#ffa500"
                    >Nästa
                    <v-icon style="font-size:15px;margin-left:3px"
                        >fas fa-arrow-right</v-icon
                    ></v-btn
                >
            </v-container>
            <v-dialog v-model="adddialog" width="500">
                <v-alert>
                    Tiden har lagts till
                    <v-divider></v-divider>
                    <v-btn color="primary" text @click="adddialog = false">
                        Ok
                    </v-btn>
                </v-alert>
            </v-dialog>
            <v-dialog v-model="rmdialog" width="500">
                <v-alert>
                    Tid borttagen
                    <v-divider></v-divider>
                    <v-btn color="primary" text @click="rmdialog = false">
                        Ok
                    </v-btn>
                </v-alert>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    data: () => ({
        store: store,
        name: "Step2",
        dateNow: "",
        date: null,
        dates: [],
        schedule: [],
        time: [],
        times: [],
        menu: [],
        stime: [],
        ftime: [],
        menu2: [],
        adddialog: false,
        rmdialog: false,
        replyDeadline: store.state.schedule.replyDeadline,
        ifNeeded: store.state.schedule.ifNeeded,
        oneAns: store.state.schedule.oneAns,
        hidSchedule: store.state.schedule.hidSchedule,
        contactInfo: store.state.schedule.contactInfo,
        adminOnly: store.state.schedule.adminOnly,
        config: {},
        replyDate: store.state.schedule.replyDate,
        disabledDates: new Date(Date.now() - 8640000),
        nowDate: new Date().toISOString().slice(0,10),
        ci0: undefined,
        ci1: undefined,
        ci2: undefined,
        ci3: undefined
    }),
    watch: {
        date: function() {
            this.add();
            // console.log(val);
        }
    },
    created: function() {
        let date = new Date();
        this.dateNow = `${date.getFullYear()}-0${date.getMonth()}-${date.getDate()}`;

    },

    methods: {
        allowedMinutes: v => v % 5 == 0,
        next: async function() {
            this.config = {
                schedule: this.store.state.schedule.time,
                replyDeadline: this.replyDeadline,
                ifNeeded: this.ifNeeded,
                oneAns: this.oneAns,
                hidSchedule: this.hidSchedule,
                contactInfo: this.contactInfo,
                adminOnly: this.adminOnly,
                replyDate: this.replyDate,
                ci0: this.ci0,
                ci1: this.ci1,
                ci2: this.ci2,
                ci3: this.ci3,
                ci4: this.ci4
            };
            if (this.dates.toString() === "") {
                this.store.state.alertMsg = "Du måste välja minst en tidpunkt.";
                this.store.state.showAlert = true;
                this.store.state.alertType = "error";
                return;
            }
            await this.store.dispatch("step2", this.config);
            this.store.state.e1++;
        },
        add: function() {
            if (this.date === null) return;
            this.dates[this.dates.length] = this.date;
            this.menu[this.dates.length] = false;
            this.menu2.push(false);
        },
        setTime: function(indate, i) {
            let date = {
                date: indate,
                stime: this.stime[i],
                ftime: this.ftime[i]
            };
            let j = this.store.state.schedule.time.length;
            this.store.state.schedule.time[j] = date;
            this.adddialog = true;
        },
        removeDate: function(date) {
            this.dates.splice(date, 1);
            this.store.state.schedule.time.splice(date, 1);
            this.menu2.splice(date);
            this.rmdialog = true;
        },
        back: function() {
            this.store.state.e1--;
        },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        }
    }
};
</script>

<style scopped>
.input {
    margin-left: 10px;
    max-height: 40px;
    margin-top: 10px;
    border: 2px solid black;
}
.inputtime {
    margin-left: 10px;
    max-height: 45px;
    border: 2px solid black;
}
</style>
